import React from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/CommonComponents/BaselineVsActual/components/Tooltip.module.scss';
import { CustomizedTooltip } from 'components/common';

interface Props {
    actual: {
        versionName: string;
        versionDate: number;
        startDate: number;
        finishDate: number;
    };
}

export const ActualTooltip = ({ actual }: Props) => {
    return (
        <div data-testid={'table-selection'}>
            <table className={'tooltipTable'}>
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Version Name</th>
                        <th>version date</th>
                        <th>start date</th>
                        <th>finish date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className={classes.spacer} />
                    <tr data-testid={'table-latest'} className={classes.latest}>
                        <td>Latest (actual)</td>
                        <td className={classes.noWrap}>
                            <CustomizedTooltip
                                tooltipPosition={TooltipPosition.Top}
                                tooltipContent={actual.versionName}
                                triggerElement={<div className={classes.ellipsis}>{actual.versionName}</div>}
                            />
                        </td>
                        <td>
                            {moment(actual.versionDate).isValid()
                                ? moment(actual.versionDate).format(constants.formats.date.default)
                                : 'N/A'}
                        </td>
                        <td>
                            {moment(actual.startDate).isValid()
                                ? moment(actual.startDate).format(constants.formats.date.default)
                                : 'N/A'}
                        </td>
                        <td>
                            {moment(actual.finishDate).isValid()
                                ? moment(actual.finishDate).format(constants.formats.date.default)
                                : 'N/A'}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
